import React, { useState } from 'react';
import {
  federalStateLoginSchema,
  IFederalStateLogin,
} from '../../Interfaces/IFederalStateLogin';
import { IUser } from '../../Interfaces/IUser';
import { IUserGroup } from '../../Interfaces/IUserGroup';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TableCell,
  TableRow,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { EditFederalStateLogin } from './EditFederalStateLogin';
import { IFederalState } from '../../Interfaces/IAemter';
import { useUpdateFedearalStateLogin } from '../../hooks/reactQuerys/FederalStateLoginQueries';
import { useAlert } from '../../context/AlertContext';

interface IProps {
  federalStateLogin: IFederalStateLogin;
  federalState: IFederalState;
  federalStateLogins: IFederalStateLogin[];
  users: IUser[];
  userGroups: IUserGroup[];
  refetchFederalStateLogins: Function;
}

export const FedearlStateLoginRow: React.FC<IProps> = ({
  federalStateLogin,
  federalState,
  federalStateLogins,
  users,
  userGroups,
  refetchFederalStateLogins,
}) => {
  const { showAlert } = useAlert();
  const currentUser = users.find(
    user => user.idUser === federalStateLogin.Notary_idUser
  );
  const { updateFederalStateLogin, isPendingUpdateFederalStateLogin } =
    useUpdateFedearalStateLogin();
  //
  const isPending = isPendingUpdateFederalStateLogin;
  //
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  //
  const [normaleLogin, setNormalLogin] = useState(federalStateLogin);
  const [stepOneLogin, setStepOneLogin] = useState(
    federalStateLoginSchema.parse({
      isFirstStage: true,
      Notary_idUser: federalStateLogin.Notary_idUser,
      idFederalState: federalStateLogin.idFederalState,
    })
  );

  const handleEdit = () => {
    setNormalLogin(federalStateLogin);
    const testObject = federalStateLogins.find(
      fslogin =>
        fslogin.idFederalStateLogin ===
        federalStateLogin.Parent_idFederalStateLogin
    );
    if (testObject) {
      setStepOneLogin(
        federalStateLoginSchema.parse({
          ...testObject,
          Notary_idUser: federalStateLogin.Notary_idUser,
          idFederalState: federalStateLogin.idFederalState,
        })
      );
    } else {
      setStepOneLogin(
        federalStateLoginSchema.parse({
          isFirstStage: true,
          Notary_idUser: federalStateLogin.Notary_idUser,
          idFederalState: federalStateLogin.idFederalState,
        })
      );
    }
    setIsOpenEdit(true);
  };

  const handleUpdate = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      // Erstzugang wird separat verwaltet — hier nur der Zugang selbst.
      const uploadObject = federalStateLoginSchema.parse(normaleLogin);
      await updateFederalStateLogin(uploadObject);
      showAlert({
        text: 'Erfolgreich gespeichert!',
        severity: 'success',
      });
      setIsOpenEdit(false);
      refetchFederalStateLogins();
    } catch (error) {
      console.error(error);
      showAlert({
        text: 'Es ist ein Fehler aufgetretten!',
        severity: 'error',
      });
    }
  };

  if (currentUser === undefined) {
    return (
      <TableRow>
        <TableCell colSpan={5}>
          Fehler: Benutzer konnte nicht bestimmt werden!
        </TableCell>
      </TableRow>
    );
  }

  return (
    <>
      {isOpenEdit && (
        <Dialog
          open
          onClose={() => setIsOpenEdit(false)}
          maxWidth='xs'
          fullWidth
        >
          <DialogTitle>Zugang bearbeiten</DialogTitle>
          <form onSubmit={handleUpdate}>
            <DialogContent>
              <EditFederalStateLogin
                federalState={federalState}
                normalLogin={normaleLogin}
                setNormalLogin={setNormalLogin}
                stepOneLogin={stepOneLogin}
                setStepOneLogin={setStepOneLogin}
                users={users}
                userGroups={userGroups}
                federalStateLogins={federalStateLogins}
              />
            </DialogContent>
            <DialogActions>
              <Button
                disabled={isPending}
                variant='outlined'
                onClick={() => setIsOpenEdit(false)}
              >
                Abbruch
              </Button>
              <Button variant='contained' disabled={isPending} type='submit'>
                {isPending ? (
                  <Box display='flex' alignItems='center' gap={1}>
                    <span>Speichern</span>
                    <CircularProgress size={20} />
                  </Box>
                ) : (
                  'Speichern'
                )}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      )}

      <TableRow>
        <TableCell>
          <Box sx={{ ml: 2 }}>
            {`${currentUser.FirstName} ${currentUser.LastName}`}
          </Box>
        </TableCell>
        <TableCell>{`${federalStateLogin.Username}`}</TableCell>
        <TableCell>{`${federalStateLogin.SecondName}`}</TableCell>
        <TableCell>
          <IconButton size='small' onClick={handleEdit}>
            <Edit />
          </IconButton>
          <IconButton size='small'>
            <Delete />
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  );
};
